module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Medium.2de688e2.woff2";